export default "__VITE_ASSET__DERA4aIA__"